export default "__VITE_ASSET__BRZcSEEV__"